import {
  GET_ACTIVE_TABLE_COLUMN,
  SET_ACTIVE_TABLE_COLUMN_ACTION,
  SET_ACTIVE_TABLE_COLUMN_MUTATION,
} from '@/views/laboratory/store/actions'
import { getLaboratoryTableColumns, setLaboratoryTableColumns } from '@/core'

export const laboratoryColumnState = {
  activeColumns: getLaboratoryTableColumns() || [0, 1, 2],
}
export const laboratoryColumnGetters = {
  [GET_ACTIVE_TABLE_COLUMN]: state => state.activeColumns,
}
export const laboratoryColumnActions = {
  [SET_ACTIVE_TABLE_COLUMN_ACTION]: ({ commit }, payload) => {
    setLaboratoryTableColumns(payload)
    commit(SET_ACTIVE_TABLE_COLUMN_MUTATION, payload)
  },
}
export const laboratoryColumnMutations = {
  [SET_ACTIVE_TABLE_COLUMN_MUTATION]: (state, payload) => {
    state.activeColumns = payload
  },
}
